import React from 'react';
import styled from 'styled-components';
import Skeleton, {SkeletonProps} from '@material-ui/lab/Skeleton';
import {ParagraphSkeleton, ParagraphSkeletonProps} from '.';

const CheckBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export interface CheckBoxSkeleton extends SkeletonProps {
    ParagraphSkeletonProps?: Partial<ParagraphSkeletonProps>;
}

const CheckBoxSkeleton: React.FC<CheckBoxSkeleton> = ({ParagraphSkeletonProps, ...props}) => (
    <CheckBox>
        <Skeleton variant="rect" width={25} height={24} {...props} style={{borderRadius: 4}} />
        <ParagraphSkeleton
            type="radio"
            style={{margin: '10px 15px', width: '100%'}}
            {...ParagraphSkeletonProps}
        />
    </CheckBox>
);

export default CheckBoxSkeleton;
